import Reveal from "@/components/Reveal";

export default function Empty({ icon: Icon, title, text, testid = "empty-state" }) {
  return (
    <Reveal>
      <div
        data-testid={testid}
        className="rounded-2xl border border-dashed border-navy-900/20 bg-white/60 px-8 py-16 text-center"
      >
        {Icon && (
          <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-navy-900 text-gold">
            <Icon className="h-6 w-6" aria-hidden />
          </div>
        )}
        <h3 className="font-serif text-2xl text-navy-900">{title}</h3>
        <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-slate-600">{text}</p>
      </div>
    </Reveal>
  );
}
